import { render, staticRenderFns } from "./Solicitudes_factoring.vue?vue&type=template&id=7ab9fbe5&"
import script from "./Solicitudes_factoring.vue?vue&type=script&lang=ts&"
export * from "./Solicitudes_factoring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports